import { AgGridVue } from 'ag-grid-vue'
import { instance, errorService } from '@/services/api'
import { updateAnalysisSheetRowStyle, strikeAnalysisCalculations } from '@/services/grid'
import _ from 'lodash'
import {
  calculateHeight,
  showNotification,
  evaluateQantity,
  convertCalculationForTemplateAnalysisSheet,
} from '@/services/calculate'
import InputEditor from '@/components/DynamicComponents/Renderers/inputEditor'
import CheckboxRender from '@/components/DynamicComponents/Renderers/checkboxRender'
import SelectEditor from '@/components/DynamicComponents/Renderers/selectEditorDynamic'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import QuantityPerRenderer from '@/components/DynamicComponents/Renderers/quantityPerRenderer'
import AutoCompleteRenders from '@/components/DynamicComponents/Renderers/autoCompleteRenders'
import ActionRenderer from '@/components/DynamicComponents/Renderers/actionRendere'
import LockRenderes from '@/components/DynamicComponents/Renderers/lockRenderer'
import CalculationEditor from '@/components/DynamicComponents/Renderers/calculationEditor'
import { templateAPIs } from '@/services/authConstantsV1'
import { socketEvents, replaceKeys, tableName } from '@/services/config'
import InputNumberEditor from '@/components/DynamicComponents/Renderers/inputNumberEditor'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import TakeoffComponent from '@/components/DynamicComponents/Admin/MasterData/TakeOff'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/templateTooltipRenderer'
import NumberRender from '@/components/DynamicComponents/Renderers/numberRenderer'
import TakeoffSelectEditor from '@/components/DynamicComponents/Renderers/takeoffSelectEditor'
import TextEditor from '@/components/DynamicComponents/Renderers/textEditor'
import FactorSelectEditor from '@/components/DynamicComponents/Renderers/factorEditor'
import exportTemplates from '@/components/DynamicComponents/Projects/Export'

export default {
  props: [
    'child',
    'templateData',
    'screenIndentifier',
    'dropdownData',
    'projectModule',
    'type',
    'viewOnly',
    'columnSettings',
  ],
  components: {
    'ag-grid-vue': AgGridVue,
    TakeoffComponent,
    exportTemplates,
  },
  data() {
    return {
      dropdownInfo: this.dropdownData,
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        rowDragManaged: true,
        animateRows: true,
        defaultColDef: {
          sortable: true,
          resizable: true,
          editable: !this.viewOnly,
          suppressMovable: true,
          wrapText: true,
          menuTabs: ['filterMenuTab'],
        },
      },
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '440px',
      data: [],
      tableState: null,
      enableDeleteClone: false,
      openCreate: false,
      columnDefs: [],
      loader: false,
      selectedRowKeys: [],
      visible: false,
      columnList: [],
      drawerHeight: null,
      visibleDrawer: false,
      sortedData: [],
      newlyAddedRecord: undefined,
      colKey: 'takeoff',
      selectUnlockRowKeys: [],
      isCalculationError: false,
      calculationData: this.templateData,
      title: 'Loading data...',
      templateInfo: this.templateData,
      isUpdate: false,
      id: undefined,
      postSort: null,
      exportClicked: false,
      url: templateAPIs.analysisSheet.export(this.$route.params.id),
      isChecked: false,
    }
  },
  beforeMount() {
    this.loaderConfig()
    this.postSort = rowNodes => {
      this.sortedData = []
      for (let i = 0; i < rowNodes.length; i++) {
        if (rowNodes[i].data.categoryCode) {
          rowNodes[i].data.categoryCode = Number(rowNodes[i].data.categoryCode)
        }
        if (rowNodes[i].data.editedFields) {
          rowNodes[i].data.editedFields = replaceKeys(
            JSON.parse(rowNodes[i].data.editedFields),
          )
        }
        this.sortedData.push(rowNodes[i].data)
      }
      this.data = [...this.sortedData]
    }
  },
  mounted() {
    this.getAnalysisData()
    this.$root.$off('saveAnalysisData')
    this.$root.$on('saveAnalysisData', this.onUpdateTakeoff)
    this.child.$off('addNewRecord')
    this.child.$on('addNewRecord', this.addNewRecord)
    this.$root.$off('deleteRecord')
    this.$root.$on('deleteRecord', this.deleteRecord)
    this.$root.$off('cloneTakeOff')
    this.$root.$on('cloneTakeOff', this.cloneTakeOff)
    this.child.$off('cloneTakeOff')
    this.child.$on('cloneTakeOff', this.cloneTakeOff)
    this.child.$off('deleteTakeOff')
    this.child.$on('deleteTakeOff', this.deleteTakeOff)
    this.$socketHub.$off('message-received')
    this.$socketHub.$on('message-received', this.messageRecived)
    window.addEventListener('resize', this.getWindowSize)
    this.$root.$off('showDrawer')
    this.$root.$on('showDrawer', this.showTemplateDrawer)
    this.$root.$off('unlockRow')
    this.$root.$on('unlockRow', this.unlockRow)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
    this.$root.$off('showDrawer')
  },
  methods: {
    loaderConfig() {
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        inputCellEditor: InputEditor,
        selectEditor: SelectEditor,
        costPriceCellRenderer: CurrencyRenderer,
        checkboxCellRender: CheckboxRender,
        autocomplete: AutoCompleteRenders,
        quantityPerCellRenderer: QuantityPerRenderer,
        lockRenderer: LockRenderes,
        inputNumberEditor: InputNumberEditor,
        customFilter: CustomFilter,
        toolTipRenderer: ToolTipRenderer,
        numberRender: NumberRender,
        calculationEditor: CalculationEditor,
        takeoffSelectEditor: TakeoffSelectEditor,
        textEditor: TextEditor,
        factorSelectEditor: FactorSelectEditor,
      }
      this.columnDefs = [
        {
          headerName: '',
          field: 'isLocked',
          headerTooltip: 'Locked',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'isLocked'),
          headerClass: 'header-center',
          width: 30,
          editable: false,
          cellRenderer: 'lockRenderer',
          cellRendererParams: {
            type: 'AnalysisSheet',
            dataType: 'int',
            viewOnly: this.viewOnly,
          },
          suppressSizeToFit: true,
          resizable: false,
          floatingFilter: false,
          hide: true,
          menuTabs: [],
        },
        {
          headerName: 'ID',
          headerTooltip: 'ID',
          valueGetter: params => {
            return params.data.sequence
          },
          headerClass: 'analysis-header-center',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'ID'),
          width: 50,
          wrapText: false,
          editable: false,
          suppressSizeToFit: true,
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'analysisSheet' },
          menuTabs: [],
        },
        {
          headerName: 'Suite #',
          field: 'suite',
          headerTooltip: 'Suite #',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'suite', 'left'),
          width: 80,
          wrapText: false,
          editable: false,
          filter: 'customFilter',
          suppressSizeToFit: true,
          resizable: true,
          hide: false,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'analysisSheet' },
        },
        {
          headerName: 'Tenant',
          field: 'tenant',
          headerTooltip: 'Tenant',
          headerClass: 'analysis-header-left',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'tenant', 'left'),
          width: 150,
          wrapText: false,
          editable: false,
          filter: 'customFilter',
          suppressSizeToFit: true,
          resizable: true,
          hide: false,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'analysisSheet' },
        },
        {
          headerName: 'Contract',
          field: 'contract',
          headerTooltip: 'Contract',
          sort: 'asc',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'contract', 'left'),
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          headerClass: 'analysis-header',
          editable: false,
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'contract',
          },
        },
        {
          headerName: 'Contract Name',
          field: 'contractName',
          headerTooltip: 'Contract Name',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'contractName', 'left'),
          width: 150,
          wrapText: false,
          filter: 'customFilter',
          suppressSizeToFit: true,
          editable: false,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'contractName',
          },
        },
        {
          headerName: 'Category Code',
          field: 'categoryCode',
          sort: 'asc',
          headerTooltip: 'Category Code',
          filter: 'customFilter',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'categoryCode', 'left'),
          width: 100,
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          headerClass: 'analysis-header',
          editable: false,
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'categoryCode',
          },
        },
        {
          headerName: 'Category Description',
          field: 'categoryCodeDescription',
          headerTooltip: 'Category Description',
          filter: 'customFilter',
          cellStyle: params =>
            updateAnalysisSheetRowStyle(params, 'categoryCodeDescription', 'left'),
          width: 150,
          wrapText: false,
          suppressSizeToFit: true,
          editable: false,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'categoryCodeDescription',
          },
        },
        {
          headerName: 'Asset Class',
          field: 'assetClass',
          headerTooltip: 'Asset Class',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'assetClass', 'left'),
          width: 100,
          suppressSizeToFit: true,
          editable: false,
          filter: 'customFilter',
          hide: true,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'assetClass',
          },
        },
        {
          headerName: 'Life',
          field: 'life',
          headerTooltip: 'Life',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'life', 'left'),
          width: 100,
          suppressSizeToFit: true,
          editable: false,
          filter: 'customFilter',
          hide: true,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'life',
          },
        },
        {
          headerName: 'Takeoff Grouping',
          field: 'takeoffGrouping',
          headerTooltip: 'Takeoff Grouping',
          width: 200,
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'takeoffGrouping', 'left'),
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'takeoffGrouping',
          },
          hide: true,
          editable: false,
        },
        {
          headerName: 'Group',
          field: 'interiorGroup',
          headerTooltip: 'Group',
          cellEditor: 'inputCellEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'string',
          },
          width: 100,
          filter: 'customFilter',
          headerClass: 'header-left',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'interiorGroup', 'left'),
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Additional Description',
          field: 'additionalDescription',
          headerClass: 'header-center',
          cellStyle: params =>
            updateAnalysisSheetRowStyle(params, 'additionalDescription', 'center'),
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'string',
            placeholder: 'Additional Description',
          },
          width: 150,
          headerTooltip: 'Additional Description',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          filter: 'customFilter',
        },
        {
          headerName: 'Takeoff Description',
          field: 'takeoff',
          headerTooltip: 'Takeoff',
          width: 400,
          cellEditor: 'takeoffSelectEditor',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'takeoff', 'left'),
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'string',
          },
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Calculation',
          field: 'calculation',
          cellEditor: 'calculationEditor',
          cellStyle: params =>
            strikeAnalysisCalculations(params, 'calculation', 'left'),
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'string',
            name: 'calculation',
            dropdownData: this.dropdownInfo.calculation,
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Calculation',
          resizable: true,
          width: 100,
          headerClass: 'header-left',
          filter: 'customFilter',
        },
        {
          headerName: 'Group Quantity',
          field: 'groupQuantity',
          headerTooltip: 'Group Quantity',
          cellEditor: 'inputCellEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'string',
          },
          width: 100,
          filter: 'customFilter',
          headerClass: 'header-left',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'groupQuantity', 'right'),
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Quantity',
          field: 'quantity',
          headerTooltip: 'Quantity',
          cellEditor: 'inputNumberEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'int',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'quantity', 'right'),
          width: 100,
          suppressSizeToFit: true,
          headerClass: 'header-right',
          filter: 'customFilter',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Unit',
          field: 'unit',
          headerTooltip: 'Unit',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'unit'),
          cellRendererParams: {
            type: 'analysisSheet',
          },
          headerClass: 'header-center',
          width: 100,
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRenderer: 'toolTipRenderer',
          editable: false,
        },
        {
          headerName: 'Unit Price',
          field: 'unitCost',
          headerTooltip: 'Unit Price',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'unitCost', 'right'),
          cellRendererParams: {
            type: 'analysisSheet',
          },
          headerClass: 'header-right',
          width: 120,
          suppressSizeToFit: true,
          filter: 'customFilter',
          editable: false,
        },
        {
          headerName: 'Multiplier',
          field: 'multiplier',
          headerTooltip: 'Multiplier',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'multiplier', 'right'),
          width: 70,
          cellEditor: 'inputNumberEditor',
          cellRendererParams: {
            name: 'multiplier',
            type: 'analysisSheet',
            dataType: 'decimal',
            precision: 3,
            min: 0,
          },
          filter: 'customFilter',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          headerClass: 'header-right',
        },
        {
          headerName: 'Total Price',
          field: 'totalPrice',
          headerTooltip: 'Total Price',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'totalPrice', 'right'),
          width: 150,
          cellRendererParams: {
            searchType: 'string',
          },
          editable: false,
          filter: 'customFilter',
          suppressSizeToFit: true,
          headerClass: 'header-right',
        },
        {
          headerName: 'Time Factor',
          field: 'timeFactor',
          headerTooltip: 'Time Factor',
          valueGetter: params => {
            return params.data.timeFactor
              ? parseFloat(params.data.timeFactor).toFixed(4)
              : params.data.timeFactor
          },
          cellEditor: 'inputNumberEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'int',
            precision: 4,
            min: 0,
            fixed: 4,
            isCheck: true,
          },
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'timeFactor', 'right'),
          width: 80,
          filter: 'customFilter',
          suppressSizeToFit: true,
          cellRenderer: 'numberRender',
          headerClass: 'header-right',
        },
        {
          headerName: 'Location Factor',
          field: 'locationFactor',
          headerTooltip: 'Location Factor',
          valueGetter: params => {
            return params.data.locationFactor
              ? parseFloat(params.data.locationFactor).toFixed(3)
              : params.data.locationFactor
          },
          cellEditor: 'inputNumberEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'int',
            precision: 3,
            min: 0,
            fixed: 3,
            isCheck: true,
          },
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'locationFactor', 'right'),
          width: 80,
          filter: 'customFilter',
          suppressSizeToFit: true,
          cellRenderer: 'numberRender',
          headerClass: 'header-right',
        },
        {
          headerName: 'Construction Quality Factor',
          field: 'constructionQualityFactor',
          headerTooltip: 'Construction Quality Factor',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'constructionQualityFactor'),
          cellEditor: 'factorSelectEditor',
          cellRendererParams: {
            name: 'constructionQualityFactor',
            type: 'analysisSheet',
            showValue: true,
            dataType: 'string',
            dropdownName: 'construction_quality_factor',
            dropdownData: this.dropdownInfo,
          },
          headerClass: 'analysis-header-center',
          width: 100,
          filter: 'customFilter',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Condition Factor',
          field: 'conditionFactor',
          headerTooltip: 'Condition Factor',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'conditionFactor'),
          headerClass: 'analysis-header-center',
          cellEditor: 'factorSelectEditor',
          cellRendererParams: {
            name: 'conditionFactor',
            type: 'analysisSheet',
            showValue: true,
            dataType: 'string',
            dropdownName: 'condition_factor',
            dropdownData: this.dropdownData,
          },
          width: 100,
          filter: 'customFilter',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Soft Cost',
          field: 'softCost',
          headerTooltip: 'Soft Cost',
          width: 100,
          cellRenderer: 'quantityPerCellRenderer',
          cellEditor: 'inputNumberEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'string',
            precision: 2,
            min: 0,
            max: 100,
          },
          suppressSizeToFit: true,
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'softCost', 'right'),
          filter: 'customFilter',
          headerClass: 'header-right',
        },
        {
          headerName: 'RCN',
          field: 'rcn',
          headerTooltip: 'RCN',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'rcn', 'right'),
          cellRendererParams: {
            searchType: 'string',
          },
          width: 150,
          editable: false,
          filter: 'customFilter',
          suppressSizeToFit: true,
          headerClass: 'header-right',
        },
        {
          headerName: 'RCNLD',
          field: 'rcnld',
          headerTooltip: 'RCNLD',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'rcnld', 'right'),
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: {
            searchType: 'string',
          },
          width: 150,
          editable: false,
          filter: 'customFilter',
          suppressSizeToFit: true,
          headerClass: 'header-right',
        },
        {
          headerName: 'Avoid Variance',
          field: 'avoidVariance',
          headerTooltip: 'Avoid Variance',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'avoidVariance'),
          headerClass: 'analysis-header-center',
          width: 70,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'templateAnalysisSheet',
            dataType: 'int',
            viewOnly: this.viewOnly,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Variance Factor',
          field: 'varianceFactor',
          headerTooltip: 'Variance Factor',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'varianceFactor'),
          headerClass: 'analysis-header-center',
          editable: false,
          width: 70,
          filter: 'customFilter',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'analysisSheet', name: 'varianceFactor' },
        },
        {
          headerName: 'Allocated Cost',
          field: 'allocatedCost',
          headerTooltip: 'Allocated Cost',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: params => updateAnalysisSheetRowStyle(params, 'allocatedCost', 'right'),
          cellRendererParams: {
            searchType: 'string',
          },
          width: 150,
          editable: false,
          filter: 'customFilter',
          suppressSizeToFit: true,
          headerClass: 'header-right',
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          cellRenderer: 'actionCellRenderer',
          headerClass: 'analysis-header-center',
          cellRendererParams: {
            type: 'analysisSheet',
            screenType: 'AnalysisSheet',
          },
          floatingFilter: false,
          width: 60,
          suppressSizeToFit: true,
          pinned: 'right',
          hide: this.viewOnly,
          menuTabs: [],
        },
      ]
    },

    getData(params) {
      params.api.setColumnDefs(this.columnDefs)
      params.api.setRowData(this.data)
      this.height = calculateHeight('analysisSheetTable', true)
      this.drawerHeight = Number(this.height.split('px')[0]) - 20 + 'px'
      this.getColumnSettings(params)
    },

    refreshColumns() {
      const columns = JSON.stringify(this.columnDefs)
      const displayColumns = JSON.parse(columns)
      displayColumns.map(col => {
        let align = ''
        if (col.cellStyle) {
          align = col.cellStyle.textAlign
        }
        if (col.field !== 'action') {
          col.cellStyle = param => updateAnalysisSheetRowStyle(param, col.field, align)
        }
        if (col.headerName !== 'Action' && col.headerName !== '') {
          col.filter = 'customFilter'
        }
      })
      return displayColumns
    },

    getAnalysisData() {
      this.loader = true
      const url = templateAPIs.analysisSheet.getTakeoffs(this.$route.params.id)
      instance
        .get(url)
        .then(res => {
          this.data = _.get(res.data, 'result', [])
          let isShow = false
          if (this.data.length > 0) {
            this.data.forEach((element, index) => {
              element.columnId = index + 1
              if (element.isLocked) {
                isShow = true
              }
              if (element.calculation) {
                element.formula = convertCalculationForTemplateAnalysisSheet(
                  element.calculation,
                  element,
                  this.dropdownInfo.calculation,
                )
                if (evaluateQantity(element.formula) < 0) {
                  element.quantity = element.quantity < 0 ? null : element.quantity
                }
              }
              if (element.editedFields) {
                element.editedFields = replaceKeys(
                  JSON.parse(element.editedFields),
                )
              }
            })
            this.gridOptions.api.setRowData(this.data)
            this.checkPreference()
            this.gridOptions.columnApi.applyColumnState({
              state: [
                {
                  colId: 'isLocked',
                  hide: !isShow,
                },
              ],
            })
          } else {
            this.data = []
            this.gridOptions.api.setRowData([])
            this.checkPreference()
            this.gridOptions.api.redrawRows()
          }
          this.onSetFocusCell()
          this.loader = false
          this.title = 'Loading data...'
        })
        .catch(err => {
          this.loader = false
          this.title = 'Loading data...'
          errorService(err)
        })
    },

    deleteRecord(record) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete this row?`,
        content: h => (
          <div style="color:red">
            <p>
              This action will delete all information related to selected
              takeoff
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(record)
        },
        onCancel() { },
      })
    },

    deleteTakeOff() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected takeoff ?`,
        content: h => (
          <div style="color:red">
            <p>
              This action will delete all information related to selected
              takeoff
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() { },
      })
    },

    confirmDelete(record) {
      this.loader = true
      const url = templateAPIs.analysisSheet.deleteTakeoffs(
        this.$route.params.id,
      )
      const ids = record ? [record.id] : this.selectedRowKeys
      this.loaderDelete = true
      instance
        .delete(url, { data: ids })
        .then(response => {
          showNotification(
            'success',
            'Delete',
            _.get(response.data, 'message', null),
          )
          ids.map(element => {
            const findIndex = this.data.findIndex(val => val.id === element)
            if (findIndex > -1) {
              this.data.splice(findIndex, 1)
            }
          })
          this.selectedRowKeys = []
          this.enableDeleteClone = false
          this.loader = false
          this.getAnalysisData()
          this.$emit('enableExtraButtons', false)
          this.$emit('loadTemplateSideBar')
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    cloneTakeOff(id) {
      const req = id ? [id] : this.selectedRowKeys
      const url = templateAPIs.analysisSheet.cloneTakeoffs(
        this.$route.params.id,
      )
      this.loader = true
      instance
        .put(url, req)
        .then(res => {
          this.selectedRowKeys = []
          this.enableDeleteClone = false
          this.getAnalysisData()
          this.$emit('enableExtraButtons', false)
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    unlockRow(record) {
      let ids = [record.id]
      const isPresent = this.selectUnlockRowKeys.find(i => i === record.id)
      if (isPresent) {
        ids = this.selectUnlockRowKeys
      }
      const url = templateAPIs.analysisSheet.unlockTakeoffs(
        this.$route.params.id,
      )
      this.loader = true
      instance
        .put(url, ids)
        .then(response => {
          showNotification(
            'success',
            'Row unlocked',
            _.get(
              response.data,
              'message',
              `${ids.length > 1 ? 'Rows' : 'Row'} has been unlocked`,
            ),
          )
          this.selectUnlockRowKeys = []
          this.selectedRowKeys = []
          this.getAnalysisData()
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    onModelUpdated() {
      if (this.newlyAddedRecord) {
        const indexOfNewRecord = this.gridOptions.api.rowModel.rowsToDisplay.findIndex(
          val => val.data.id === this.newlyAddedRecord,
        )
        this.gridOptions.api.setFocusedCell(indexOfNewRecord, this.colKey)
        this.gridOptions.api.startEditingCell({
          rowIndex: indexOfNewRecord,
          colKey: this.colKey,
        })
        this.newlyAddedRecord = undefined
        this.colKey = 'takeoff'
      }
      if (
        this.gridOptions.api &&
        this.gridOptions.api.rowModel.rowsToDisplay.length === 0
      ) {
        this.gridOptions.api.showNoRowsOverlay()
      }
      if (
        this.gridOptions.api &&
        this.gridOptions.api.rowModel.rowsToDisplay.length > 0
      ) {
        this.gridOptions.api.hideOverlay()
      }
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectUnlockRowKeys = selectedNodes
        .filter(i => i.data.isLocked)
        .map(node => node.data.id)
      this.enableDeleteClone = selectedData.length > 0
      this.$emit('enableExtraButtons', selectedData.length > 0)
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectUnlockRowKeys = selectedNodes
        .filter(i => i.data.isLocked)
        .map(node => node.data.id)
      this.enableDeleteClone = selectedData.length > 0
      this.$emit('enableExtraButtons', selectedData.length > 0)
    },

    closeCreate(action) {
      this.openCreate = false
    },

    onUpdateTakeoff(value, record, key, indexData, takeoffData, data) {
      var takeoffs = null
      if (key === 'takeoff' && takeoffData) {
        takeoffs = {
          takeoffId: takeoffData.id,
          takeoffGroupingId: takeoffData.takeoffGroupingId,
          contractId: takeoffData.mContractDetailsId,
          categoryCodeId: takeoffData.mCategoryCodeId,
          unitId: takeoffData.mUnitId,
          unitCost: takeoffData.unitCost,
          source: takeoffData.source,
        }
      }
      const url = templateAPIs.analysisSheet.updateTakeoffs(
        this.$route.params.id,
      )
      this.tableState = this.gridOptions.columnApi.getColumnState()
      this.title = 'Please wait while updating analysis sheet...'
      const request = []
      const isPresent = this.selectedRowKeys.find(i => i === record.id)
      if (!isPresent) {
        this.selectedRowKeys = []
        this.selectedRowKeys.push(record.id)
      }
      this.selectedRowKeys.forEach(element => {
        const takeoff = this.data.find(i => i.id === element)
        let isManuallyAdded = true
        if (takeoff) {
          isManuallyAdded = takeoff.isManuallyAdded
        }
        if (!isManuallyAdded && key !== 'interiorGroup') {
          const editedFields = record.editedFields
            ? JSON.parse(record.editedFields)
            : []
          const isCheck = editedFields.find(i => i === key)
          if (!isCheck) {
            editedFields.push(key)
          }
          request.push({
            id: element,
            isLocked: true,
            editedFields: JSON.stringify(editedFields),
          })
        } else {
          request.push({ id: element })
        }
      })
      switch (key) {
        case 'takeoff':
          request.forEach(element => {
            Object.assign(element, {
              mTakeoffId: takeoffData.id,
              takeoffGroupingId: takeoffData.takeoffGroupingId,
              unitCost: takeoffData.unitCost,
              contractId: takeoffData.contractId,
              categoryCodeId: takeoffData.categoryCodeId,
              unitId: takeoffData.unitId,
              source: takeoffData.source,
            })
          })
          break
        case 'calculation':
          request.forEach(element => {
            const takeoff = this.data.find(i => i.id === element.id)
            let isManuallyAdded = true
            if (takeoff) {
              isManuallyAdded = takeoff.isManuallyAdded
            }
            if (!isManuallyAdded) {
              element.editedFields = JSON.parse(element.editedFields)
              const isCheck = element.editedFields.find(i => i === 'quantity')
              if (!isCheck) {
                element.editedFields.push('quantity')
              }
              element.editedFields = JSON.stringify(element.editedFields)
            }
            Object.assign(element, {
              [key]: value,
              quantity: evaluateQantity(record.formula) > 0 ? evaluateQantity(record.formula) : null,
            })
          })
          break
        case 'quantity':
          request.forEach(element => {
            Object.assign(element, {
              [key]: value || null,
            })
          })
          break
        case 'constructionQualityFactor':
          request.forEach(element => {
            Object.assign(element, {
              constructionQualityFactorId: value || null,
              [key]: data ? Number(data.value) : null,
            })
          })
          break
        case 'conditionFactor':
          request.forEach(element => {
            Object.assign(element, {
              conditionFactorId: value || null,
              [key]: data ? Number(data.value) : null,
            })
          })
          break
        default:
          request.forEach(element => {
            Object.assign(element, {
              [key]: value,
            })
          })
          break
      }
      var newRecord = record
      newRecord[key] = value
      if (takeoffs && takeoffs.contractId) {
        newRecord.contractId = takeoffs.contractId
      }
      if (takeoffs && takeoffs.categoryCodeId) {
        newRecord.categoryCodeId = takeoffs.categoryCodeId
      }
      if (takeoffs && takeoffs.unitId) {
        newRecord.unitId = takeoffs.unitId
      }
      if (takeoffs && takeoffs.unitCost) {
        newRecord.unitCost = takeoffs.unitCost
      }
      if (key === 'calculation' && evaluateQantity(record.formula) < 0) {
        // validateNumber(0, 'quantity', 'Quantity')
      }
      if ((newRecord.quantity || (newRecord.formula && key === 'takeoff'))) {
        if (((newRecord.contractId || newRecord.contract) || (key === 'takeoff' && request.isApplicationMaster)) && ((newRecord.categoryCodeId || newRecord.categoryCode) || (key === 'takeoff' && request.isApplicationMaster)) && (Boolean(newRecord.takeoff)) && ((Boolean(newRecord.unitId) || newRecord.unit) || (key === 'takeoff' && request.isApplicationMaster)) && (Boolean(newRecord.unitCost)) &&
          (Boolean(newRecord.conditionFactorId) || (Boolean(record.conditionFactor))) && (key === 'multiplier' || Boolean(record.multiplier)) && (newRecord.totalPrice || (key === 'quantity' && newRecord.quantity)) && newRecord.timeFactor && newRecord.locationFactor &&
          (newRecord.constructionQualityFactor || newRecord.constructionQualityFactorId)) {
          newRecord.isValidTakeoff = true
        } else {
          newRecord.isValidTakeoff = false
        }
      }
      request.forEach(e => {
        if (e.id === record.id) {
          e.isValidTakeoff = newRecord.isValidTakeoff
        }
      })
      this.onUpdate(value, url, request, key, record)
    },

    onUpdate(value, url, request, key, record) {
      const currentValue =
        value || key === 'avoidVariance' ? value.toString() : undefined
      const previousValue = window.previousValue
        ? window.previousValue.toString()
        : undefined
      if (previousValue !== currentValue) {
        this.isUpdate = true
        this.loader = true
        instance
          .patch(url, request)
          .then(response => {
            showNotification(
              'success',
              'Analysis Sheet',
              'Analysis sheet has been updated successfully!',
            )
            switch (key) {
              case 'avoidVariance':
                this.id = undefined
                this.gridOptions.api.tabToNextCell()
                break
              case 'conditionFactor':
              case 'constructionQualityFactor':
              case 'takeoff':
                this.id = record.id
                this.gridOptions.api.tabToNextCell()
                break

              default:
                break
            }
            this.selectedRowKeys = []
            this.gridOptions.api.redrawRows()
            this.getAnalysisData()
            this.$emit('enableExtraButtons', false)
          })
          .catch(err => {
            this.loader = false
            errorService(err)
          })
      }
    },

    addNewRecord() {
      const url = templateAPIs.analysisSheet.addTakeoffs(this.$route.params.id)
      this.loader = true
      let newData = [...this.data]
      instance
        .post(url)
        .then(res => {
          this.loader = false
          if (_.get(res.data, 'result', [])) {
            // newData = newData.concat([_.get(res.data, 'result', [])])
            var newRecords = [_.get(res.data, 'result', [])]
            newRecords.map(e => {
              e.isValidTakeoff = true
            })
            newData = newData.concat(newRecords)
            this.data = [...newData]
            this.data.map((value, index) => {
              value['columnId'] = index + 1
              if (value.calculation) {
                value.formula = convertCalculationForTemplateAnalysisSheet(
                  value.calculation,
                  value,
                  this.dropdownInfo.calculation,
                )
              }
              return value
            })
            this.gridOptions.api.setRowData(this.data)
            this.gridOptions.api.redrawRows()
            const result = _.get(res.data, 'result', [])
            this.newlyAddedRecord = result.id
          }
        })
        .catch(err => {
          errorService(err)
        })
    },

    getWindowSize() {
      this.height = calculateHeight('analysisSheetTable', true)
    },

    showDrawer() {
      this.visible = !this.visible
      if (!this.visible) {
        this.drawerHeight = Number(this.height.split('px')[0]) - 20 + 'px'
      }
    },

    checkPreference() {
      this.columnList = []
      this.tableState
        .filter(
          i =>
            i.colId !== 'action' &&
            i.colId !== 'display' &&
            i.colId !== '0' &&
            i.colId !== 'isLocked' &&
            i.colId !== 'life',
        )
        .forEach(element => {
          if (element.colId === 'tenantName') {
            element.colId = 'tenant'
          }
          if (element.colId === '1') {
            Object.assign(element, { pinned: 'left' })
          }
          if (element.colId === 'allocatedCost') {
            Object.assign(element, { pinned: 'right' })
          }
          const headerName = this.columnDefs.find(
            i => i.field && i.field === element.colId,
          )
          if (headerName) {
            headerName.headerName =
              headerName.headerName === 'Takeoff'
                ? 'Takeoff Description'
                : headerName.headerName
            this.columnList.push({
              colId: element.colId,
              hide: element.hide,
              isCheck: !element.hide,
              name: headerName.headerName,
            })
          }
        })
      const isPresent = this.tableState.find(i => i.colId === 'groupQuantity')
      if (!isPresent) {
        const element = {
          header: 'Group Quantity',
          colId: 'groupQuantity',
          width: 100,
          hide: false,
          pinned: null,
          sort: null,
          sortIndex: null,
          aggFunc: null,
          rowGroup: false,
          rowGroupIndex: null,
          pivot: false,
          pivotIndex: null,
          flex: null,
          display: true,
        }
        const index = this.tableState.findIndex(i => i.colId === 'quantity')
        this.tableState.splice(index, 0, element)
        const columnIndex = this.columnList.findIndex(i => i.colId === 'quantity')
        this.columnList.splice(columnIndex, 0, {
          colId: element.colId,
          hide: element.hide,
          isCheck: !element.hide,
          name: element.header,
        })
      }
      if (isPresent) {
        const element = this.tableState.find(i => i.colId === 'groupQuantity')
        const index = this.tableState.findIndex(i => i.colId === 'quantity')
        this.tableState.splice(index, 0, element)
      }
      const isPresentColumn = this.columnList.find(i => i.colId === 'groupQuantity')
      if (isPresentColumn) {
        const element2 = this.columnList.find(i => i.colId === 'groupQuantity')
        const index2 = this.columnList.findIndex(i => i.colId === 'quantity')
        this.columnList.splice(index2, 0, element2)

        const unitElement = this.columnList.find(i => i.colId === 'unit')
        const unitIndex = this.columnList.indexOf(unitElement)
        const quantityElement = this.columnList.find(i => i.colId === 'quantity')
        const quantityIndex = this.columnList.indexOf(quantityElement)
        if (unitIndex - 1 === quantityIndex) {
          this.columnList.splice(unitIndex - 2, 1)
        } else if (unitIndex - 1 !== quantityIndex) {
          this.columnList.splice(unitIndex - 1, 1)
        }
      }
      this.gridOptions.columnApi.applyColumnState({
        state: this.tableState,
        applyOrder: true,
      })
      if (this.templateData.structureProfileId !== 3) {
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'suite',
              hide: true,
            },
            {
              colId: 'tenantName',
              hide: true,
            },
          ],
        })
        this.columnList = this.columnList.filter(
          i => i.colId !== 'suite' && i.colId !== 'tenantName',
        )
      }
      this.isChecked = this.columnList.every(i => i.isCheck)
    },

    onChange(e, column) {
      column.isCheck = e.target.checked
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: column.colId,
            hide: !column.isCheck,
          },
        ],
      })
      this.isChecked = this.columnList.every(i => i.isCheck)
      this.tableState = this.gridOptions.columnApi.getColumnState()
      this.updateColumnSetting()
    },

    onSelectAll(e) {
      this.isChecked = e.target.checked
      this.columnList.forEach(element => {
        element.isCheck = e.target.checked
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: element.colId,
              hide: !element.isCheck,
            },
          ],
        })
      })
      this.tableState = this.gridOptions.columnApi.getColumnState()
      this.updateColumnSetting()
    },

    updateColumnState() {
      instance
        .patch(templateAPIs.template.updateTemplate(this.$route.params.id), {
          columnsDetails: JSON.stringify(this.tableState),
        })
        .then(response => {
          this.loading = false
          this.templateInfo.columnsDetails = JSON.stringify(this.tableState)
        })
        .catch(err => {
          errorService(err)
        })
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSetting()
      }
    },

    showTemplateDrawer(flag) {
      this.visibleDrawer = flag
    },

    onCellValueChanged(event) {
      if (event.colDef.field === 'calculation') {
        if (event.value) {
          const calculation = convertCalculationForTemplateAnalysisSheet(
            event.value,
            event.data,
            this.dropdownInfo.calculation,
          )
          event.data.formula = calculation
          event.data.isUpdate = true
          const reg = /^[0-9. ()]+([-+*/()]+[ -+()]?[ 0-9.()]+)*$/
          if (!reg.test(calculation)) {
            showNotification(
              'error',
              'Calculation',
              `Invalid formula, please validate the formula!`,
            )
            this.isCalculationError = true
            const focusedCell = this.gridOptions.api.getFocusedCell()
            if (focusedCell) {
              this.gridOptions.api.setFocusedCell(
                focusedCell.rowIndex,
                'calculation',
              )
              this.gridOptions.api.startEditingCell({
                rowIndex: focusedCell.rowIndex,
                colKey: 'calculation',
              })
            }
          } else {
            this.onUpdateTakeoff(
              event.value,
              event.data,
              event.colDef.field,
              event.rowIndex,
              null,
              null,
            )
          }
        } else {
          event.data.formula = undefined
          event.data.isUpdate = false
          this.onUpdateTakeoff(
            event.value,
            event.data,
            event.colDef.field,
            event.rowIndex,
            null,
            null,
          )
        }
      }
    },

    tabToNextCell(params) {
      const previousCell = params.previousCellPosition
      const nextCellPosition = params.nextCellPosition
      let result = null
      result = {
        rowIndex: nextCellPosition.rowIndex,
        column: nextCellPosition.column,
        floating: previousCell.floating,
      }
      return result
    },

    onSetFocusCell() {
      if (this.isUpdate) {
        const focusedCell = this.gridOptions.api.getFocusedCell()
        let rowIndex = focusedCell.rowIndex
        const colId = focusedCell.column.colId
        if (this.id) {
          rowIndex = this.data.findIndex(val => val.id === this.id)
        }
        if (focusedCell && rowIndex !== this.data.length - 1) {
          this.gridOptions.api.setFocusedCell(rowIndex, colId)
          this.gridOptions.api.startEditingCell({
            rowIndex: rowIndex,
            colKey: colId,
          })
        }
      }
      this.isUpdate = false
    },

    exportSheet() {
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    messageRecived(message) {
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.updateVarianceFactor) {
        this.getAnalysisData()
      } else if (data.EventType === socketEvents.templateSideBarUpdated) {
        this.loader = false
        this.$root.$emit('templateSideBarUpdated', message)
      } else if (data.EventType === socketEvents.analysisSheetUpdated) {
        this.getAnalysisData()
      } else if (data.EventType === socketEvents.fileExported) {
        this.$root.$emit('message-received', message)
      } else if (data.EventType === socketEvents.error) {
        this.loader = false
        showNotification(
          'error',
          'Socket',
          _.get(data, 'Result.Message', null),
        )
      }
    },

    getColumnSettings(params) {
      const columnDetails = this.columnSettings.find(
        i => i.screenId === 6 && i.tableName === 'AnalysisSheet',
      )
      if (columnDetails && columnDetails.columnDetails) {
        this.tableState = JSON.parse(columnDetails.columnDetails)
      } else if (this.templateInfo && this.templateInfo.columnsDetails) {
        this.tableState = JSON.parse(this.templateInfo.columnsDetails)
      } else {
        this.tableState = this.gridOptions.columnApi.getColumnState()
      }
    },

    updateColumnSetting() {
      const tableState = this.gridOptions.columnApi.getColumnState()
      const request = {
        screenId: 6,
        tableName: tableName.template.analysisSheet,
        columnDetails: JSON.stringify(tableState),
      }
      this.$emit('updateColumnSettings', request)
    },

    sortChanged() {
      this.updateColumnSetting()
    },
  },
}
